import React, { memo } from 'react'
import { NavLink } from 'react-router-dom'
import { bool, string, oneOf, node } from 'prop-types'

import classNames from '../../helpers/class-names'

import './_style.scss'

const blk = 'asda-link'

const Link = ({
  category,
  asButton,
  asAnchor,
  type,
  href,
  target,
  align,
  disabled,
  standalone,
  clickHandler,
  dataAutoId,
  className,
  children,
  ...rest
}) => {
  const eltClass = classNames({
    blk,
    className,
    mods: [
      category,
      disabled && 'disabled',
      standalone && 'standalone',
      (standalone && align) && `align-${align}`,
      asButton && 'button',
    ],
  })

  if (asButton) {
    return (
      // eslint-disable-next-line react/button-has-type
      <button
        type={type}
        data-auto-id={dataAutoId}
        className={eltClass}
        onClick={clickHandler}
        disabled={disabled}
        aria-disabled={disabled}
        {...rest}
      >
        {children}
      </button>
    )
  }

  if (asAnchor) {
    return (
      <a
        data-auto-id={dataAutoId}
        href={href}
        target={target}
        className={eltClass}
        onClick={clickHandler}
        {...rest}
      >
        {children}
      </a>
    )
  }

  return (
    <NavLink
      to={href}
      className={eltClass}
      data-auto-id={dataAutoId}
    >
      {children}
    </NavLink>
  )
}

export const clickHandlerPropType = (props) => {
  const { asButton, clickHandler } = props
  if (asButton && (clickHandler === undefined || typeof (clickHandler) !== 'function')) {
    return new Error('Required prop clickHandler was not specified in Link Component')
  }
  return null
}


Link.propTypes = {
  category: oneOf(['primary', 'secondary', 'clear']),
  type: oneOf(['button', 'submit', 'reset']),
  align: string,
  asButton: bool,
  asAnchor: bool,
  href: string,
  target: string,
  disabled: bool,
  standalone: bool,
  dataAutoId: string,
  className: string,
  children: node.isRequired,
  // eslint-disable-next-line react/require-default-props
  clickHandler: clickHandlerPropType,
}

Link.defaultProps = {
  category: 'primary',
  align: '',
  type: 'button',
  asButton: false,
  asAnchor: false,
  href: '/',
  target: '_self',
  disabled: false,
  standalone: false,
  dataAutoId: '',
  className: '',
}

export default memo(Link)



// WEBPACK FOOTER //
// ./common/components/link/index.js